<label
  [ngClass]="{
    'avatar-picker-button ion-activatable': !ref.children.length,
    'avatar-picker-button_disabled': isLoading,
  }"
>
  @if (!ref.children.length) {
    @if (!isLoading) {
      <img [src]="cameraIcon" alt="Прикрепить фото" />
    }
    <ion-ripple-effect></ion-ripple-effect>
    <app-spinner [isLoading]="isLoading" [color]="SpinnerColor.light"></app-spinner>
  }

  <div #ref>
    <ng-content></ng-content>
  </div>

  <input
    type="file"
    hidden
    [accept]="availableImageFormats"
    (change)="handleImageInputChange($event)"
  />
</label>
